import axiosClient from "../../../../../system/helpers/axiosConfig";

export const postTranslation = (params) => {
  return axiosClient
    .post(`api/translations/save-bulk`, params)
    .then((r) => r.data);
};
